import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=54c4b975&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=54c4b975&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4b975",
  null
  
)

/* custom blocks */
import block0 from "./OrderDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c4b975')) {
      api.createRecord('54c4b975', component.options)
    } else {
      api.reload('54c4b975', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=54c4b975&scoped=true", function () {
      api.rerender('54c4b975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrderDetail.vue"
export default component.exports